import React, { useEffect, useState } from "react";
import {
  stopPlayingAudio,
  getDefaultLanguage,
  getUserToken,
  getUserCadre,
  getUserKb,
  getAgents,
  getUserType,
  getOnboardingFlag,
  getConsentFlag,
  getTooltip,
  handleTooltipOnboarding,
  getLanguageChangeFlag,
  setLanguageChangeFlag,
  getParamToken,
  setUserToken,
  setUserType,
  setUserId,
  CheckLanguageSupport,
  setAgents,
  setTooltip,
  setUserCadre,
  setUserKb,
  saveOnboardingFlag,
  saveConsentFlag,
  setUserApproach,
  isIframeDeployment,
  isPwaInstalled,
  getDeferredPrompt,
} from "../../../Actions/Utils";
import {
  guideButtons,
  languagePreferenceConstant,
  nextConstant,
  selectLanguageConstant,
  codeToSvgName,
} from "../../../NewConstants/IntroductionConstants";
import { generateSpeech } from "../../../Actions/ChatActions";
import { useNavigate } from "react-router-dom";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { getLanguages } from "../../../Actions/UserActions";
import { iframeLogin } from "../../../Actions/UserActions";
import platform from "platform";
import { NeGD } from "../../../NewConstants/DeploymentConstants";

const IndicLang = ({
  selectedLanguage,
  setSelectedLanguage = () => {},
  audioRef,
  setStepIndex,
  setStartTour,
}) => {
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [languages, setLanguages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const navigate = useNavigate();
  const LANG_ICON_PATH = "/Assets/Images/Lang/";

  useEffect(() => {
    async function fetchLanguages() {
      setLoading(true);
      if (getUserCadre() && getUserKb()) {
        const res = await getLanguages(getUserCadre(), getUserKb());
        if (res?.status === 200 && res.data?.languages) {
          setLanguages(res.data.languages);
        } else {
          setLanguages([]);
          setShowToastMessage(true);
          setToastErrorMessage("No languages found");

        }
      }else{
        const res = await getLanguages();
        if (res?.status === 200 && res.data?.languages) {
          setLanguages(res.data.languages);
        } else {
          setLanguages([]);
          setShowToastMessage(true);
          setToastErrorMessage("No languages found");
        }
      }
      setLoading(false);
    }
    fetchLanguages();
  }, []);
  
  useEffect(() => {

    if (getLanguageChangeFlag() === "true") {
      if (getAgents() && getUserType() === "Internal") {
        navigate("/kb-selection");
      } else {
        if (!getOnboardingFlag()) {
          navigate("/guide");
        } else {
          if (!getConsentFlag() && !isIframeDeployment()) {
            navigate("/consent");
          } else {
            const tooltip = getTooltip();
            handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
            navigate("/chat");
          }
        }
      }
    }
  }, [navigate]);

  useEffect(() => {
    // Set initial selected language from getDefaultLanguage
    if (!selectedLanguage) {
      const defLang = getDefaultLanguage() || "en";
      if (defLang) setSelectedLanguage(defLang);
    }
  }, [selectedLanguage, setSelectedLanguage]);

  useEffect(() => {
    const handleAudio = async () => {
      const res = await generateSpeech(
        languagePreferenceConstant[selectedLanguage],
        selectedLanguage
      );
      if (res?.data?.url) {
        const newAudio = new Audio(res?.data?.url);
        if (audioRef.current) {
          audioRef.current.pause();
        }
        newAudio.addEventListener("ended", () => {
          setShowSpeakerActive(false);
        });
        audioRef.current = newAudio;
        newAudio.play().catch((err) => {
          console.error("Error playing audio:", err);
        });
      } else {
        setToastErrorMessage(res?.data?.detail);
        setShowToastMessage(true);
        setShowSpeakerActive(false);
      }
    };
    if (showSpeakerActive) handleAudio();
  }, [showSpeakerActive, selectedLanguage]);

  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [audioRef, navigate]);

  const handleSelect = (code) => {
    setSelectedLanguage(code);
  };

  const goToNext = async (data) => {
    setAgents(data?.agents);
    setTooltip(data?.tooltip_data);
    if (data?.agents.length <= 0){
      navigate("/lang");
    }else{
      if (data?.type === "Internal" && data?.agents.length > 1){
        navigate("/kb-selection");
      }else{
        const agent = data.agents[0];
        setUserCadre(agent?.cadre);
        setUserKb(agent?.kb);
        setUserApproach(agent?.approach);
        saveOnboardingFlag(agent?.onboarding);
        saveConsentFlag(agent?.consent);
        if (!agent?.onboarding){
          navigate("/guide");
        }else{
          await navigateBasedOnSupport();
        }
      }
    }
  };

  const navigateBasedOnSupport = async () => {
    const route = await CheckLanguageSupport();
    if (route === "chat"){
      const tooltip = getTooltip();
      handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
      navigate("/chat");
    }else if (route === "language-check"){
      navigate("/language-check");
    }else{
      navigate("/lang");
    }
  };

  const iframeLoginFun = async () => {
    const deviceData = {
      device_name: platform.manufacturer || "Unknown",
      device_os: platform.os?.family || "Unknown",
      device_version: platform.os?.version || "Unknown",
    };

    const browserData = {
      browser_name: platform.name || "Unknown",
      browser_version: platform.version || "Unknown",
    };
    const res = await iframeLogin(getParamToken(), deviceData, browserData, selectedLanguage, NeGD.Cadre, NeGD.Kb, NeGD.Approach);
    if (res?.status === 200) {
      if (res?.data?.token) {
        setUserToken(res?.data?.token);
        setUserType(res?.data?.user_data?.type);
        setUserId(res?.data?.user_data?.user_id);
        goToNext(res?.data?.user_data);
      }
    } else if (res?.status === 503) {
      setToastErrorMessage(res?.data?.error?.message);
      setShowToastMessage(true);
    } else if (res?.status === 401) {
      setToastErrorMessage(res?.data?.error?.message);
      setShowToastMessage(true);
    }
  }
  const handleConfirm = () => {
    const token = getUserToken();
    if (token) {
      if (getAgents() && getUserType() === "Internal") {
        navigate("/kb-selection");
        setLanguageChangeFlag("true");
      } else {
        if (!getOnboardingFlag()) {
          navigate("/guide");
          setLanguageChangeFlag("true");
        } else {
          if (!getConsentFlag() && !isIframeDeployment()) {
            navigate("/consent");
            setLanguageChangeFlag("true");
          } else {
            const tooltip = getTooltip();
            handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
            navigate("/chat");
            setLanguageChangeFlag("true");
          }
        }
      }
    }else if(getParamToken()){
      iframeLoginFun();
    }else if (!isPwaInstalled() && getDeferredPrompt()){
      navigate("/install");
    } else {
      navigate("/login");
    }
  };

  return (
    <div
      style={{overflow: "scroll", backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
      className="bg-[var(--primary-dark-2)] h-screen w-screen relative bg-blend-color-burn"
    >
      <div className="relative h-full flex flex-col items-center">
        {isIframeDeployment() && (
          <div className="h-[3.75rem] w-full flex justify-end ">
          </div>
        )}
        <div className="w-full p-6 pb-2 flex justify-end ">
          <div
            className={`speakerDiv ${
              showSpeakerActive ? "Active" : ""
            }`}
            onClick={() => {
              setShowSpeakerActive(!showSpeakerActive);
              stopPlayingAudio(audioRef);
            }}
          >
            {showSpeakerActive
              ? guideButtons.stop[selectedLanguage]
              : null}
            {showSpeakerActive ? (
              <div className="">
                <img
                  src={"/Assets/Images/blueSpeaker.svg"}
                  alt="active Speaker"
                />
              </div>
            ) : (
              <div className="">
                <img
                  src={"/Assets/Images/crossSpeakerIcon.svg"}
                  alt="speaker"
                />
              </div>
            )}
          </div>
        </div>
        <div className="relative h-full w-full flex flex-col items-center ">
        <div className="relative w-full h-[80%] flex flex-col items-center">
        <div className="flex flex-col items-center justify-center text-[2rem]">
          <img src={"/Assets/Images/Logo.svg"} alt="asha" />
        </div>
        <div className="font-bold text-white text-[1.5rem] mt-4">
            {selectLanguageConstant[selectedLanguage] || "Select Language"}
          </div>
        <div className="flex flex-wrap justify-center gap-4 mt-4">
          {loading ? (
            <div className="col-span-3 text-white">Loading...</div>
          ) : (
            languages.map((lang) => {
              const isSelected = selectedLanguage === lang.value;
              // Use English name from code for SVG file
              const engName = codeToSvgName[lang.value];
              const color = isIframeDeployment() ? "Red" : "Blue";
              const svgFile = `${LANG_ICON_PATH}${engName} - ${
                isSelected ? color : "White"
              }.svg`;
              return (
                <div key={lang.value} className="flex flex-col items-center justify-center">
                  <div
                    key={lang.label}
                    className={`flex flex-col items-center justify-center rounded-full border-2 cursor-pointer ${
                      isSelected ? `bg-white shadow-lg` : ""
                    } p-2 w-[4.91rem] h-[4.91rem]`}
                    style={{ borderColor: isSelected ? "var(--primary-dark-2)" : "var(--light-neutral-2)" }}
                    onClick={() => handleSelect(lang.value)}
                  >
                    <img
                      src={svgFile}
                      alt={lang.label}
                    />
                  </div>
                  <span className={`text-base ${selectedLanguage === lang.value ? "font-bold" : ""} text-white`}>
                    {lang.label}
                  </span>
                </div>
              );
            })
          )}
        </div>
        </div>
        <div className="w-full h-[20%] flex justify-center">
        <div className="w-[8.75rem] h-[2.875rem]">
            {selectedLanguage && <NextBtn
              value={nextConstant[selectedLanguage]}
              icon={isIframeDeployment() ? "/Assets/Images/nextRedIcon.svg" : "/Assets/Images/nextBlueIcon.svg"}
              bgColor={"var(--neutral-white)"}
              color={"var(--primary-dark)"}
              nextClick={handleConfirm}
              disabled={!selectedLanguage}
              textCenter={true}
              padx={12}
              pady={8}
            />}
        </div>
        </div>
        </div>
      </div>
      {showToastMessage && <ToastMessage message={toastErrorMessage} direction="bottom" close={() => setShowToastMessage(false)} />}
    </div>
  );
};

export default IndicLang;
